import React, { Component } from "react";
import { connect } from "react-redux";
import { EditAppBundleDialog } from "../dialogs/EditAppBundleDialog";
import { asArray, mapKV } from "../utils/map";
import { vrTypesToString } from "../utils/appUtils";
import { editAppBundle } from "../redux/actions/appBundleActions";

export class EditAppBundle extends Component {
  state = {
    name: "",
    description: "",
    nameNotUnique: false,
    saveAvaliable: true,
    selectedApps: {},
    organizationKey: "",
    globalAccess: false
  };

  componentDidMount() {
    const {
      name,
      description = "",
      appRefs,
      organizationRef,
      globalAccess
    } = this.props.selectedBundle;
    let selectedApps = {};
    if (!!appRefs) appRefs.map(ref => (selectedApps[ref.id] = true));
    const organizationKey = organizationRef.id;
    this.setState({
      name,
      description,
      selectedApps,
      organizationKey,
      globalAccess
    });
  }

  extractApps = () => {
    const { apps } = this.props;
    let managedApps = [];
    let externalApps = [];
    let genericKey = 0;
    asArray(apps).map(app => {
      const { key, apkUrl, iconUrl, title, packageName, vrTypes } = app;
      const row = [
        <img
          src={iconUrl}
          style={{ width: 50, margin: 5 }}
          key={genericKey++}
          alt="App Icon"
        />,
        title,
        packageName,
        vrTypesToString(vrTypes)
      ];
      if (apkUrl) managedApps.push({ key, row });
      else externalApps.push({ key, row });
    });
    return { managedApps, externalApps };
  };

  onNameChange = name => this.setState({ name }, this.checkSaveAvaliable);

  onDescriptionChange = description => this.setState({ description });

  onOrganizationChange = organizationKey =>
    this.setState({ organizationKey }, this.checkSaveAvaliable);

  checkSaveAvaliable = () => {
    const { name, organizationKey } = this.state;
    const { contentBundles, selectedKey } = this.props;

    let nameNotUnique = false;
    mapKV(contentBundles, (key, bundle) => {
      if (key === selectedKey) return;
      if (name.trim() === bundle.name) nameNotUnique = true;
    });
    this.setState({ nameNotUnique });

    let saveAvaliable = true;
    if (name.trim() === "" || nameNotUnique || organizationKey === "")
      saveAvaliable = false;
    this.setState({ saveAvaliable });
  };

  onAppSelect = ({ key, value }) => {
    let { selectedApps } = this.state;
    selectedApps[key] = value;
    this.setState({ selectedApps });
  };

  onGlobalAccessChange = globalAccess => this.setState({ globalAccess });

  onSave = () => {
    const {
      name,
      description,
      selectedApps,
      organizationKey,
      globalAccess
    } = this.state;
    const { selectedKey, onClose, editAppBundle } = this.props;
    let selectedAppKeys = [];
    mapKV(selectedApps, (k, v) => {
      if (v) selectedAppKeys.push(k);
    });
    editAppBundle({
      key: selectedKey,
      name,
      description,
      selectedAppKeys,
      organizationKey,
      globalAccess
    });
    onClose();
  };

  render() {
    const { onClose, selectedBundle } = this.props;
    const {
      name,
      description,
      nameNotUnique,
      saveAvaliable,
      selectedApps,
      organizationKey,
      globalAccess
    } = this.state;
    return (
      <EditAppBundleDialog
        onClose={onClose}
        onSave={this.onSave}
        selectedBundle={selectedBundle}
        name={name}
        onNameChange={this.onNameChange}
        nameNotUnique={nameNotUnique}
        saveAvaliable={saveAvaliable}
        description={description}
        onDescriptionChange={this.onDescriptionChange}
        apps={this.extractApps()}
        selectedApps={selectedApps}
        onAppSelect={this.onAppSelect}
        organizationKey={organizationKey}
        onOrganizationChange={this.onOrganizationChange}
        globalAccess={globalAccess}
        onGlobalAccessChange={this.onGlobalAccessChange}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    apps: state.data.apps,
    contentBundles: state.data.contentBundles
  };
};

const mapDispatchToProps = { editAppBundle };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditAppBundle);
